import { useEffect, useState } from "react";

import { TimeSpan } from "../TimeSpan";

export function useDetectFirstRender(delay?: TimeSpan) {
  const [firstRender, setFirstRender] = useState(true);
  useEffect(() => {
    let timer: number;
    if (delay)
      timer = window.setTimeout(
        () => setFirstRender(false),
        delay.milliseconds,
      );
    else setFirstRender(false);

    return () => clearTimeout(timer);
  }, [delay]);

  return firstRender;
}
